import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss']
})
export class CheckboxComponent implements OnInit {
  arrayComponent: any;
  componentRender: any;
  infoComponent: any;
  constructor() {

    this.arrayComponent = [
      {
        id: 'solo',
        titulo: 'Input independiente',
        subtitulo: `Input type <code>checkbox</code> para una única opción..`,
        claseContainer: 'col-6',
        componentRender:
          `
<label class="checkbox-govco">
    <input type="checkbox" id="checkbox_simple_solo" />
    <label for="checkbox_simple_solo"> Acepto los términos y condiciones </label>
</label>

`,
      },
      {
        id: 'checkbox',
        titulo: 'Input checkbox sin opciones seleccionada',
        subtitulo: `Input type <code>checkbox</code> sin ninguna opción seleccionada de forma predeterminada.`,
        claseContainer: 'col-6',
        componentRender:
          `
<label class="checkbox-govco checklist-govco">
    <input type="checkbox" id="checkbox_simple_1" />
    <label for="checkbox_simple_1"> Primera opción </label>
</label>

<label class="checkbox-govco checklist-govco">
    <input type="checkbox"  id="checkbox_simple_2" />
    <label for="checkbox_simple_2"> Segunda opción </label>
</label>

<label class="checkbox-govco checklist-govco">
    <input type="checkbox" id="checkbox_simple_3" />
    <label for="checkbox_simple_3"> Tercera opción </label>
</label>

<!--Check Desactivado-->
<label class="checkbox-govco checklist-govco ">
    <input type="checkbox" id="checkbox_simple_4" />
    <label for="checkbox_simple_4"> Cuarta opción  </label>
</label>
`,
      },
      {
        id: 'checkbox_selected',
        titulo: 'Input checkbox con opción predeterminada',
        subtitulo: `Input type <code>checkbox</code> con opción predeterminada. A la etiqueta input se añade el atributo 
        <code>checked</code> o <code>checked="true"</code> a la opción que queremos seleccionar como predeterminada.
        `,
        claseContainer: 'col-6',
        componentRender:
          `
<label class="checkbox-govco checklist-govco">
    <input type="checkbox" id="checkbox_selected_1" />
    <label for="checkbox_selected_1"> Primera opción  </label>
</label>

<label class="checkbox-govco checklist-govco">
    <input type="checkbox"  id="checkbox_selected_2" />
    <label for="checkbox_selected_2"> Segunda opción </label>
</label>

<label class="checkbox-govco checklist-govco">
    <input type="checkbox" id="checkbox_selected_3" checked/>
    <label for="checkbox_selected_3"> Tercera opción (Predeterminada) </label>
</label>

<!--Check Desactivado-->
<label class="checkbox-govco checklist-govco ">
    <input type="checkbox" id="checkbox_selected_4" />
    <label for="checkbox_selected_4"> Cuarta opción  </label>
</label>
`,
      }, {
        id: 'checkbox_disabled',
        titulo: 'Input checkbox con opción deshabilitada',
        subtitulo: `Input type <code>checkbox</code> con opción deshabilitada. A la etiqueta input se añade el atributo 
        <code>disabled</code> o <code>disabled="true"</code> de la opción que queremos deshabilitar.
        `,
        claseContainer: 'col-6',
        componentRender:
          `
<label class="checkbox-govco checklist-govco">
    <input type="checkbox" id="checkbox_disabled_1" />
    <label for="checkbox_disabled_1"> Primera opción  </label>
</label>

<label class="checkbox-govco checklist-govco">
    <input type="checkbox"  id="checkbox_disabled_2" />
    <label for="checkbox_disabled_2"> Segunda opción </label>
</label>

<label class="checkbox-govco checklist-govco disabled">
    <input type="checkbox" id="checkbox_disabled_3" disabled checked/>
    <label for="checkbox_disabled_3"> Tercera opción (deshabilitada y predeterminada)</label>
</label>

<!--Check Desactivado-->
<label class="checkbox-govco checklist-govco disabled">
    <input type="checkbox" id="checkbox_disabled_4" disabled/>
    <label for="checkbox_disabled_4"> Cuarta opción (deshabilitada)</label>
</label>
`,
      }, {
        id: 'checkbox_error',
        titulo: 'Input checkbox con opción error',
        subtitulo: `Input type <code>checkbox</code> con una opción resaltada como <code>error</code>.  
        Si desea presentar una opción no válida o con algún error, puede usar la clase class="error" en la etiqueta contenedora label.
        `,
        claseContainer: 'col-6',
        componentRender:
          `
<label class="checkbox-govco checklist-govco">
    <input type="checkbox" id="checkbox_error_1" />
    <label for="checkbox_error_1"> Primera opción  </label>
</label>

<label class="checkbox-govco checklist-govco">
    <input type="checkbox"  id="checkbox_error_2" />
    <label for="checkbox_error_2"> Segunda opción </label>
</label>

<label class="checkbox-govco checklist-govco error">
    <input type="checkbox" id="checkbox_error_3" checked/>
    <label for="checkbox_error_3"> Tercera opción (con un error)</label>
</label>

<!--Check Desactivado-->
<label class="checkbox-govco checklist-govco">
    <input type="checkbox" id="checkbox_error_4"/>
    <label for="checkbox_error_4"> Cuarta opción</label>
</label>
`,
      },
    ]
    this.infoComponent = {
      titulo: "Lista de chequeo checkbox",
      descripcion: "Use los estilos para los input personalizados"
    }

  }

  ngOnInit() {
  }

  ngAfterViewInit() {
  }

}